var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { gql } from '@apollo/client';
var GET_DIMENSIONS = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  query getDimensions {\n    dimensions @client {\n      dimensions\n      measures\n      breakdowns\n    }\n  }\n"], ["\n  query getDimensions {\n    dimensions @client {\n      dimensions\n      measures\n      breakdowns\n    }\n  }\n"])));
export default GET_DIMENSIONS;
var templateObject_1;
